import { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { MessageCircle, Send } from "lucide-react";

const fmtDt = (s) => {
  try { return new Date(s).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }); }
  catch { return s || ""; }
};

// Iter122ij · Chat con filtro per canale (kind: "condomino" | "assicurazione").
// Retro-compat: messaggi senza kind vengono considerati canale "condomino".
export function SinistroChat({ sinistroId, messaggi = [], me = "Studio", kind = "condomino", title, onNew }) {
  const [testo, setTesto] = useState("");
  const [busy, setBusy] = useState(false);
  const filtered = messaggi.filter((m) => (m.kind || "condomino") === kind);

  const invia = async () => {
    const t = testo.trim();
    if (!t) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/sinistri/${sinistroId}/messaggi`, { testo: t, kind });
      setTesto("");
      onNew?.(data);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Invio non riuscito");
    } finally { setBusy(false); }
  };

  return (
    <div className="border-2 border-slate-200 rounded-lg p-4" data-testid={`sinistro-chat-${kind}`}>
      <div className="text-sm font-bold uppercase tracking-wide text-slate-600 mb-3 flex items-center gap-2">
        <MessageCircle className="w-4 h-4" /> {title || (kind === "assicurazione" ? "Chat con Compagnia/Agenzia" : "Chat con Condòmino")}
      </div>
      <div className="space-y-2 max-h-72 overflow-y-auto pr-1 mb-3" data-testid={`sinistro-chat-messages-${kind}`}>
        {filtered.length === 0 && <div className="text-sm text-slate-400">Nessun messaggio. Scrivi il primo.</div>}
        {filtered.map((m) => {
          const mine = m.autore_ruolo === me;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
              <div className={`max-w-[85%] rounded-xl px-3 py-2 border ${mine ? "bg-[#FBEEF3] border-[#EBC5D2]" : "bg-slate-50 border-slate-200"}`}>
                <div className="text-xs text-slate-500 mb-0.5">
                  <b className={mine ? "text-brand" : "text-slate-700"}>{m.autore_nome}</b> · {m.autore_ruolo} · {fmtDt(m.at)}
                </div>
                <div className="text-sm text-slate-800 whitespace-pre-wrap break-words">{m.testo}</div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex gap-2 items-end">
        <Textarea data-testid={`sinistro-chat-input-${kind}`} value={testo} onChange={(e) => setTesto(e.target.value)}
          placeholder="Scrivi un messaggio..." className="min-h-[44px] flex-1" rows={2} />
        <Button data-testid={`sinistro-chat-send-${kind}`} onClick={invia} disabled={busy || !testo.trim()}
          className="h-11 bg-brand hover:bg-brand-dark font-bold shrink-0">
          <Send className="w-4 h-4 sm:mr-1.5" /> <span className="hidden sm:inline">Invia</span>
        </Button>
      </div>
    </div>
  );
}
